
import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { useDarkroomMode } from '@/hooks/useDarkroomMode';
import { useTheme } from 'next-themes';

export const DynamicIslandHeader = () => {
  // Logic to detect if device is an iPhone with Dynamic Island
  // iPhone 14 Pro/Pro Max, iPhone 15 series and newer have Dynamic Island
  const isIOS = Capacitor.getPlatform() === 'ios' ||
                /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  // Get darkroom mode state to adjust background color accordingly
  const { darkroomMode } = useDarkroomMode();
  
  // Get current theme and theme resolved state
  const { theme, resolvedTheme } = useTheme();
  
  // State to track if theme is ready
  const [mounted, setMounted] = useState(false);

  // Wait for component to mount to access theme
  useEffect(() => {
    setMounted(true);
  }, []);

  // Only render this spacer for iOS devices
  if (!isIOS) return null;
  
  // Don't render until mounted to prevent hydration mismatch
  if (!mounted) return null;
  
  // Determine the appropriate background color based on theme
  let bgColor = 'bg-background';
  
  // Override with black in darkroom mode
  if (darkroomMode) {
    bgColor = 'bg-black';
  } 
  // For light/dark theme specific overrides when not in darkroom mode
  else if (resolvedTheme === 'dark') {
    // In dark mode, use the dark background color
    bgColor = 'bg-background dark:bg-background';
  }
  
  // For debugging - log the current theme and background class
  console.log('Dynamic Island Header - Current theme:', resolvedTheme || theme, 'Using class:', bgColor);
  
  return (
    <div className={`fixed top-0 left-0 w-full z-50 dynamic-island-spacer ${bgColor}`}>
      {/* This is an empty spacer that compensates for the Dynamic Island */}
    </div>
  );
};
